import React from 'react'
import Walkin from './components/Walkin'

const WalkinMain = () => {
  return (
    <>
    <Walkin/>
    </>
  )
}

export default WalkinMain